<template>
	<div class="prices">
		<!-- NARXLASH BO'LIMIDAGI DONA TOVARLARGA NARX BERISH COMPONENTI -->
		<div
			slot="header"
			class="top-card"
		>
            <span>

            </span>
			<div style="align-items: center;display: flex;">
				<b-link
					@click="toggleForm.form = !toggleForm.form"
					class="card-header-action btn-setting"
					style="font-size: 15px"
				>
					<i class="fa fa-search"></i>
				</b-link>
				<b-button
					variant="outline"
					@click.prevent="closeSidebar"
				>
					<i class="fa fa-close"></i>
				</b-button>

			</div>
		</div>
		<b-tabs
			style="margin-top: 0.5%"
			card
			v-model="activeTabIndex"
		>
			<b-tab
				title="Оценить (Штук)"
				active
			>
				<b-card-text>
					<b-card-group deck>
						<b-card
							header-tag="header"
							footer-tag="footer"
						>

							<b-form>
								<div class="top-form">

									<b-row class="my-1">
										<b-col cols="2">
											<b-form-select
												v-model="filterCurrencyId"
												:options="refCurrencies"
												value-field="id"
												text-field="name"
												@change="currencyChanged"
											>
												<template slot="first">
													<option :value="null">-- Все валюты --</option>
												</template>
											</b-form-select>
										</b-col>
										<b-col>
											<date-picker v-model="currentDate" lang="ru" :placeholder="$t('promo-to-product.regDate')" value-type="format" format="DD-MM-YYYY"/>
										</b-col>
										<b-col>
											<b style="display: inline-block">Вся фирма:</b> <b-checkbox class="ml-2" style="display: inline-block" v-model="allDep" switch></b-checkbox>
											<!-- <label for="input-small">
													<span class="redStar">*</span>
													{{$t('pricing.department')}}
													<span class="isErrorDepartment" v-if="isInvalid">
															{{$t('pricing.errorDepartment')}}
														</span>
												</label> -->
<!--											<multiselect-->
<!--												:options="getDepartmentsLocal()"-->
<!--												:multiple="true"-->
<!--												:value="selectedDepartment"-->
<!--												track-by="id"-->
<!--												label="name"-->
<!--												:placeholder="$t('pricing.department')"-->
<!--												@select="handleNewDepartment"-->
<!--												@remove="removeDepartment"-->
<!--												:show-labels="false"-->
<!--												:allow-empty="true"-->
<!--												class="multiselect-pricing"-->
<!--												:class="isInvalid ? 'isErrorDepartmentBorder' : ''"-->
<!--											>-->
<!--												<template-->
<!--													slot="option"-->
<!--													slot-scope="option"-->
<!--												>-->
<!--													{{-->
<!--														option.option.name-->
<!--													}} ({{-->
<!--														option.option.currencyCode ? option.option.currencyCode : 'no currency'-->
<!--													}})-->
<!--												</template>-->
<!--											</multiselect>-->
										</b-col>
										<b-col cols="3">
											<!-- <label>{{ $t('prices.filter.docPlaceholder') }} </label> -->
											<b-form-input
												id="docId"
												v-model="filter.multiBarcode"
												name="name"
												:placeholder="$t('goods.barcode')"
												@focusout="setFilterToComponent"
												@keyup.enter="searchPricing"
											>
											</b-form-input>
										</b-col>
										<b-col cols="2">
											<!-- <label>{{ $t('goods.barcode')}} </label> -->
											<b-form-input
												id="barcode"
												v-model="filter.barcode"
												name="barcode"
												:placeholder="$t('goods.special-barcode')"
												@focusout="setFilterToComponent"
												@keyup.enter="searchPricing"
											>
											</b-form-input>
										</b-col>

										<b-col :cols="companyType === 'SHOP' ? 2 : 2">
											<!-- <label>{{$t('goods.artikul')}}</label> -->
											<b-form-input
												id="artikul"
												v-model="filter.artikul"
												name="name"
												:placeholder="$t('goods.artikul')"
												@focusout="setFilterToComponent"
												@keyup.enter="searchPricing"
											>
											</b-form-input>
										</b-col>
									</b-row>

									<b-collapse
										v-model="toggleForm.form"
										id="filterColumns"
									>
										<b-container fluid>
											<b-row class="my-1">
												<!--									<b-col sm="4">-->
												<!--										<label for="input-small">-->
												<!--											<span class="redStar">*</span>-->
												<!--											{{$t('pricing.registrationNo')}}-->
												<!--										</label>-->
												<!--										<b-input-group-->
												<!--											size="sm"-->
												<!--											class="mb-3"-->
												<!--										>-->
												<!--											<b-form-input :placeholder="$t('pricing.registrationNo')" :state="isValid"-->
												<!--														  v-model="regnumber"></b-form-input>-->
												<!--											<b-input-group-append>-->
												<!--												<b-button size="sm" text="Button" variant="success"-->
												<!--														  ref="generateRegNumberRefs"-->
												<!--														  @click.prevent="generateRegNumber"-->
												<!--														  :disabled="disabledComputed">-->
												<!--													<i class="fa fa-refresh"></i>-->
												<!--												</b-button>-->
												<!--											</b-input-group-append>-->
												<!--										</b-input-group>-->
												<!--									</b-col>-->

											</b-row>

											<b-row class="my-1">
												<b-col
													:cols="companyType === 'SHOP' ? 3 : 2"
													v-if="companyType !== 'SHOP'"
												>
													<!-- <label for="input-small">
															Тип
														</label> -->
													<b-form-select
														v-model="filter.category"
														:options="allCategory"
														value-field="id"
														text-field="name"
														@change="categorySelected"
													>
														<template slot="first">
															<option value="all">-- {{ $t('Тип') }} --</option>
														</template>
													</b-form-select>
												</b-col>
												<b-col :cols="companyType === 'SHOP' ? 3 : 2">
													<!-- <label for="input-small">
															{{$t('incomes.block-counteragent.group')}}
														</label> -->
													<b-form-select
														v-model="subcategory.value"
														@change="subCategorySelected"
														:disabled="subcategory.isDisabled"
													>
														<option
															v-for="(selectOption, indexOpt) in subcategory.items"
															:key="indexOpt"
															:value="selectOption.id"
														>
															{{ selectOption.name }}
														</option>
														<template slot="first">
															<option :value="null">
																-- {{
																	companyType === 'SHOP' ?
																		$t('incomes.block-counteragent.group') : 'Все Подкатегории'
																}} --
															</option>
														</template>
													</b-form-select>

												</b-col>
												<b-col :cols="companyType === 'SHOP' ? 3 : 2">
													<!-- <label>{{$t('incomes.block-counteragent.category')}}</label> -->
													<b-form-select
														v-model="subsubcategory.value"
														@change="subSubCategorySelected"
														:disabled="subsubcategory.isDisabled"
													>
														<option
															v-for="(selectOption, indexOpt) in subsubcategory.items"
															:key="indexOpt"
															:value="selectOption.id"
														>
															{{ selectOption.name }}
														</option>
														<template slot="first">
															<option :value="null">
																-- {{
																	companyType === 'SHOP' ?
																		$t('incomes.block-counteragent.category') : 'Все Подкатегории'
																}} --
															</option>
														</template>
													</b-form-select>

												</b-col>
												<b-col :cols="companyType === 'SHOP' ? 3 : 2">
													<!-- <label>{{$t('prices.item.sub-category')}}</label> -->
													<b-form-select
														v-model="sub3category.value"
														:disabled="sub3category.isDisabled"
													>
														<option
															v-for="(selectOption, indexOpt) in sub3category.items"
															:key="indexOpt"
															:value="selectOption.id"
														>
															{{ selectOption.name }}
														</option>
														<template slot="first">
															<option :value="null">
																--
																{{
																	companyType === 'SHOP' ? $t('prices.item.sub-category') : 'Все Подкатегории'
																}}
																--
															</option>
														</template>
													</b-form-select>
												</b-col>
												<b-col cols="3">
													<!-- <label for="input-small">
															{{$t('pricing.costDate')}}
															<span class="isErrorDepartment" v-if="isInvalidDate">
															{{$t('pricing.errorDate')}}
														</span>
														</label> -->
													<masked-input
														v-model="currentDate"
														mask="11-11-1111"
														class="ml-1 form-control form-control-sm"
														:placeholder="$t('pricing.costDate')"
													/>
												</b-col>

											</b-row>
											<b-row class="my-4">
												<b-col cols="3">
													<!--<label>Наименования</label>-->
													<b-form-input
														id="name"
														v-model="filter.name"
														name="name"
														:placeholder="$t('prices.item.name')"
														@focusout="setFilterToComponent"
													>
													</b-form-input>
												</b-col>
												<b-col sm="3">
													<!--<label for="input-small">-->
													<!--&lt;!&ndash;{{$t('contragent.filter')}}&ndash;&gt;-->
													<!--</label>-->
													<!--<div class="searchInCard">-->
													<b-input-group size="sm">
														<b-form-input
															v-model="tableFilter"
															size="sm"
															:placeholder="$t('contragent.filter')"
														/>
														<b-input-group-append>
															<b-button
																:disabled="!filter"
																@click="clearPricing"
															>
																{{ $t('contragent.clear') }}
															</b-button>
														</b-input-group-append>
													</b-input-group>
													<!--</div>-->
												</b-col>
											</b-row>
										</b-container>
									</b-collapse>
									<b-collapse v-model="toggleSearch.filter" id="filterColumns">
										<b-table :items="getPricedItems" :fields="computedFieldsFilter">
											<template slot="details" slot-scope="data">
												{{ data.item.name ? data.item.name.substring(0, 20) : '' }}
											</template>
											<template slot="index" slot-scope="data">
												<span class="text-center">{{ data.index + 1 }}</span>
											</template>
											<template slot="incomeUzs" slot-scope="data">
												{{
													data.item.incomeUzs | currency({
														symbol: depCurrencyName,
														fractionCount: 2,
														symbolPosition: 'back',
														thousandsSeparator: ' '
													})
												}}
											</template>
											<template slot="multiBarcode" slot-scope="data">
												<div v-for="barcode in data.item.multiBarcodes">{{ barcode }}</div>
											</template>
											<template slot="oldPriceUzs" slot-scope="data">
												<span v-if="data.item.oldPriceUzs > 0">
													{{
														data.item.oldPriceUzs | currency({
															symbol: depCurrencyName,
															fractionCount: 2,
															symbolPosition: 'back',
															thousandsSeparator: ' '
														})
													}}
												</span><span v-else></span>
											</template>
											<template slot="uzb" slot-scope="data">
												<span v-if="data.item.priceUzs > 0">
													{{
														data.item.priceUzs | currency({
															symbol: depCurrencyName,
															fractionCount: 2,
															symbolPosition: 'back',
															thousandsSeparator: ' '
														})
													}}
												</span><span v-else></span>
											</template>
											<template
												slot="priceUzs"
												slot-scope="data"
											>
												{{
													data.item.priceUzs | currency({
														symbol: depCurrencyName,
														fractionCount: 2,
														symbolPosition: 'back',
														thousandsSeparator: ' '
													})
												}}
											</template>
											<template slot="actions" slot-scope="data">
												<b-link @click="deleteItem(data.index)">
													<i class="fa fa-trash"></i>
												</b-link>
											</template>
										</b-table>
									</b-collapse>
									<div class="row my-1 justify-content-end">
										<div class="col-3">
											<b-button
												@click="toggleSearch.filter = !toggleSearch.filter"
												variant="btn btn-info"
												block
												size="sm"
											>
												<i
													class="fa fa-money"
													style="color: white"
													aria-hidden="true"
												></i> &nbsp;
												<span
													style="color:white;">{{ $t('prices.item.priced-products') }} </span>
												<i
													style="color: white;"
													class="fa fa-arrow-down"
													aria-hidden="true"
												></i>

											</b-button>
										</div>
										<!--                                        <div class="col-2">-->
										<!--                                            <download-excel-->
										<!--                                                style="cursor: pointer"-->
										<!--                                                size="sm"-->
										<!--                                                class="btn btn-outline-primary"-->
										<!--                                                :data="items"-->
										<!--                                                :fields="json_fields1"-->
										<!--                                                worksheet="My Worksheet"-->
										<!--                                                name="Excel"-->
										<!--                                            >-->
										<!--                                                {{$t('excel-export.download-excel')}}-->
										<!--                                            </download-excel>-->
										<!--                                        </div>-->
										<div class="col-2">
											<b-button
												@click="saveREADY('SUSPENDED')"
												variant="btn btn-warning"
												block
												size="sm"
											>
												<i class="fa fa-save"></i> &nbsp;
												<span>{{ $t('actions.save') }}</span>
											</b-button>
										</div>
										<div class="col-3">
											<b-button
												v-if="$can('pricing', 'manager')"
												@click="saveREADY('READY')"
												variant="btn btn-success"
												block
												size="sm"
											>
												<i class="fa fa-save"></i> &nbsp;
												<span>{{ $t('warehouse.document.saveAndFinish') }}</span>
											</b-button>
										</div>
										<div class="col-2">
											<!--<label >{{$t('contragent.filter')}}</label>-->
											<b-button
												variant="btn btn-primary"
												size="sm"
												block
												@click="searchPricing"
											>
												<i
													class="fa fa-search"
													aria-hidden="true"
												></i> {{ $t('contragent.filter') }}
											</b-button>
										</div>
									</div>
								</div>
								<div>
									<b-alert
										variant="danger"
										:show="emptyErrorTable"
									><span class="emptyErrorTable">Пожалуйста, введите цену на товары!</span>
									</b-alert>
								</div>
								<div class="table-responsive table-wrapper">
									<b-table
										class="generalTableClass" :hover="hover" :striped="striped"
										:bordered="bordered"
										style="overflow-y: scroll;height: 500px"
										:small="small"
										:fixed="fixed"
										:filter="tableFilter"
										:items="items"
										responsive="sm"
										thead-class="fixedHeader"
										:fields="computedFields"
									>
										<template slot="id" slot-scope="data">
											<strong>{{ paginate(data.index, filter.page, filter.limit) }}</strong>
										</template>
										<template slot="details" slot-scope="data">
											{{ data.item.name }}
										</template>
										<template slot="barcode" slot-scope="data">
											{{ data.item.barcode }}
										</template>
										<template slot="artikul" slot-scope="data">
											{{ data.item.artikul }}
										</template>
										<template slot="newUzb" slot-scope="data">
											<b-form-input
												:ref="data.index + '1'"
												type="text"
												v-if="ok"
												onClick="this.setSelectionRange(0, this.value.length)"
												@keyup.up.left.right.down="focusInput($event ,data.index, 1)"
												v-model="data.item.newPriceUzs"
												v-focus
												class="move"
											/>
											<div v-else data-toggle="tooltip" :title="$t('pricing.update')"
												 @click="OkFunction(data.index + '1')">
												<div v-if="data.item.newPriceUzs > 0"> {{
														data.item.newPriceUzs |
															currency({
															symbol: depCurrencyName,
															fractionCount: 2,
															symbolPosition: 'back',
															thousandsSeparator: ' '
														})
													}}
												</div>
												<div v-else class="emptyDivForPricing"/>
											</div>
										</template>
										<template slot="multiBarcode" slot-scope="data">
											<div v-for="barcode in data.item.multiBarcodes">
												{{ barcode }}
											</div>
										</template>
										<template slot="uzb" slot-scope="data">
                                            <span v-if="data.item.priceUzs > 0">
                                                {{
													data.item.priceUzs | currency({
														symbol: depCurrencyName,
														fractionCount: 2,
														symbolPosition: 'back',
														thousandsSeparator: ' '
													})
												}}
                                            </span>
											<span v-else></span>
										</template>
										<template slot="newPriceWholesale" slot-scope="data">
											<b-form-input
												:ref="data.index + '2'"
												type="text"
												v-if="ok"
												onClick="this.setSelectionRange(0, this.value.length)"
												@keyup.up.left.right.down="focusInput($event ,data.index, 2)"
												v-model="data.item.newPriceWholesale"
												v-focus
												class="move"
											/>
											<div
												v-else
												data-toggle="tooltip"
												:title="$t('pricing.update')"
												@click="OkFunction(data.index + '2')"
											>
												<div v-if="data.item.newPriceWholesale > 0"> {{
														data.item.newPriceWholesale |
															currency({
															symbol: depCurrencyName,
															fractionCount: 2,
															symbolPosition: 'back',
															thousandsSeparator: ' '
														})
													}}
												</div>
												<div
													v-else
													class="emptyDivForPricing"
												></div>
											</div>
										</template>
										<template
											slot="lastPriceWholesale"
											slot-scope="data"
										>
                                            <span v-if="data.item.priceWholesale > 0">
                                                {{
													data.item.priceWholesale | currency({
														symbol: depCurrencyName,
														fractionCount: 2,
														symbolPosition: 'back',
														thousandsSeparator: ' '
													})
												}}
                                            </span>
											<span v-else> </span>
										</template>
									</b-table>
									<nav>
										<b-pagination :total-rows="totalItems" :per-page="filter.limit"
													  v-model="filter.page"
													  :prev-text="$t('pagination.prev')"
													  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
									</nav>
									<div
										v-if="loader"
										class="spinner-wrapper"
									>
										<b-spinner variant="primary"></b-spinner>
									</div>

									<div class="col-4 pl-0">
										<b-form-textarea
											style="height: 50px;"
											id="textarea"
											v-model="comment"
											:placeholder="$t('promo-to-product.comment')"
											rows="3"
											max-rows="6"
										></b-form-textarea>
									</div>

								</div>
							</b-form>

						</b-card>
					</b-card-group>
				</b-card-text>
			</b-tab>
			<b-tab :title="$t('pricing.addTitleWithExcel')">
				<b-card-text>
					<b-row>
						<b-col cols="4">
							<treeselect
								name="tree"
								v-model="excelDepIds"
								:options="departments"
								:show-count="true"
								auto-select-descendants
								auto-deselect-descendants
								:default-expand-level="1"
								:flat="true"
								:normalizer="normalizer"
								:multiple="true"
							>
								class="vue-tree-select-custom required"
							</treeselect>
						</b-col>
						<b-col cols="4">
							<b-form-file
								value="disabled"
								accept=".xlsx, xls"
								:placeholder="$t('excel.noChoosen')"
								:browse-text="$t('excel.choose')"
								size="sm"
								v-model="form.fileExcel"
								ref="file-input"
							></b-form-file>
						</b-col>
						<b-col cols="3">
							<b-button
								style="margin-top: 2%"
								variant="success"
								size="sm"
								class="mb-1"
								@click="download"
							>Загрузить
							</b-button>
						</b-col>
					</b-row>
					<br>
					<b-row>
						<b-col cols="3">
							<div>
								<b-button
									@click="saveForExcel('SUSPENDED')"
									variant="btn btn-warning"
									block
									size="sm"
								>
									<i class="fa fa-save"></i> &nbsp;
									<span>{{ $t('actions.save') }}</span>
								</b-button>
							</div>
						</b-col>
						<b-col cols="3">
							<div>
								<b-button
									v-if="$can('pricing', 'manager')"
									@click="saveForExcel('READY')"
									variant="btn btn-success"
									block
									size="sm"
								>
									<i class="fa fa-save"></i> &nbsp;
									<span>{{ $t('warehouse.document.saveAndFinish') }}</span>
								</b-button>
							</div>
						</b-col>
						<b-col cols="3">
							<b-button
								style="margin-left: 10%"
								variant="primary"
								class="mb-1"
								size="sm"
							>
								<a
									:href="`${publicPath}excel/Переоценка.xlsx`"
									disabled
									download
									style="color: white"
								>Скачать шаблон</a><i class="fas fa-download ml-2"></i>
							</b-button>
						</b-col>
					</b-row>

					<!-- NOT FOUND EXCEL ITEMS TABLE -->
					<h4 class="mt-2 d-inline-block mr-4">Ненайденные</h4>
<!--					<download-excel-->
<!--						style="cursor: pointer"-->
<!--						size="sm"-->
<!--						class="btn btn-outline-primary"-->
<!--						:data="notFoundExcelItems"-->
<!--						:fields="notFoundExcelItemsFields"-->
<!--						worksheet="Not Found Items"-->
<!--						name="NotFoundItems"-->
<!--					>-->
<!--						{{ $t('excel-export.download-excel') }}-->
<!--					</download-excel>-->
					<b-table
						class="mb-0"
						size="lg"
						id="table-transition-example"
						ref="table"
						small
						:items="notFoundExcelItems"
						:fields="excelFields"
						:per-page="0"
						hover="hover"
						striped="striped"
						bordered="bordered"
						show-empty
					>
						<template v-slot:empty="{}">
							<p class="text-center m-0 p-2">
								{{ ("Пустая") }}
							</p>
						</template>
						<!-- INDEX -->
						<template
							slot="id"
							slot-scope="data"
						>
							<strong> {{ data.index + 1 }} </strong>
						</template>
					</b-table>
					<br>

					<!-- FOUND EXCEL ITEMS TABLE -->
					<h4>Найденные</h4>
					<b-table
						class="mb-0"
						size="lg"
						id="table-transition-example"
						ref="table"
						small
						:items="foundExcelItems"
						:fields="excelFields"
						:per-page="0"
						hover="hover"
						striped="striped"
						bordered="bordered"
						show-empty
					>
						<template v-slot:empty="{}">
							<p class="text-center m-0 p-2">
								{{ ("Пустая") }}
							</p>
						</template>
						<!-- INDEX -->
						<template
							slot="id"
							slot-scope="data"
						>
							<strong> {{ data.index + 1 }} </strong>
						</template>
						<template slot="multiBarcode" slot-scope="data">
							<div v-for="barcode in data.item.multiBarcodes">
								{{ barcode }}
							</div>
						</template>
					</b-table>
				</b-card-text>
			</b-tab>
		</b-tabs>

		<!--		View Pending Items		-->
		<b-modal v-model="viewPendingItems" size="xl" centered hide-footer title="Эти товары в ожидании !">
			<b-table bordered striped hover :items="pendingItems" :fields="pendingCols"/>
		</b-modal>

		<!--		Confirm		-->
		<b-modal v-model="confirmModal" centered type="confirm" size="sm" hide-footer ok-variant="success" title="Подтвердите">
			Вы уверены?<br>
			<b-button class="float-right" size="sm" variant="success" @click="save">Ok</b-button>
		</b-modal>
	</div>
</template>

<script>
import TreeView from "./treeView";
import {mapActions, mapGetters, mapState} from "vuex";
import MaskedInput from 'vue-masked-input'
import Multiselect from 'vue-multiselect'
import DepartmentsService from "../../services/departments.sevice";
import ReferencesService from "../../services/references.sevice";
import {TokenService} from "../../services/storage.service";
import PriceFilter from "./PriceFilter";
import PricesService from "../../services/prices.service";

export default {

	directives: {
		focus: {
			inserted: function (el) {
				el.focus()
			}
		}
	},
	watch: {
		allDep: {
			handler(t) {
				if (t) {
					this.getDepartments.forEach(t => {
						this.selectedDepartment.push(t)
					})
				} else {
					this.selectedDepartment = []
				}
			}
		},
		getEditItems: {
			handler(newVal) {
				if (this.getEditItems && this.isSidebarOpen) {

					this.currentDate = this.getEditItems.costDate;
					this.filter.id = this.getEditItems.id;
					this.regnumber = this.getEditItems.costNumber;
					this.comment = this.getEditItems.comment
					this.getEditItems.companies.forEach(item => {
						// this.selectedDepartment.push(item)
						this.selectedDepartment.push(item);
					});
					this.toggleSearch.filter = true
					// this.searchPricing();
					// this.items = this.getEditItems.pricingItems;
					if (this.getEditItems) {
						if (this.getEditItems.pricingItems.length > 0) {
							this.getPricedItems.push(...this.getEditItems.pricingItems);
						}
					}
					this.subcategory.isDisabled = false;
				}


				// this.setCompanyType();

			}
		},
		'isSidebarOpen': {
			handler(newValue) {
				if (newValue) {
					var today = new Date();
					var dd = String(today.getDate()).padStart(2, '0');
					var mm = String(today.getMonth() + 1).padStart(2, '0');
					var yyyy = today.getFullYear();
					this.currentDate = dd + '-' + mm + '-' + yyyy;

					this.activeTabIndex = 0
					this.resetExcelTabData()
					DepartmentsService.getDepartments().then((res) => {
						this.departments = res.data;
					});
				}
			}
		},
		'count': {
			handler(newValue) {
				if (newValue > 1) {
					this.filterPricing();
				}
			}
		},
		'getRegNumber': {
			handler(newValue) {
				this.regnumber = newValue;
			}
		},

		'filter.departmentId': {
			deep: true,
			handler(newVal) {
				if (Object.keys(this.filter.departmentId).length !== 0) {
					this.setCompanyType()
					if (this.companyType === 'SHOP') {
						this.subcategory.isDisabled = false
					}
					this.disabled = false

				} else {
					this.disabled = true
					if (this.companyType !== 'SHOP') {
						this.filter.category = 'all'
						this.categoryCode = null;
					}
					this.subcategory.value = null;
					this.subsubcategory.value = null;
					this.sub3category.value = null

					this.sub3category.isDisabled = true
					this.subcategory.isDisabled = true
					this.subsubcategory.isDisabled = true
				}
			}
		},
		'filter.category': {
			handler() {
				this.subcategory.value = null
				this.subsubcategory.value = null
				this.sub3category.value = null
			}
		},
		'filter.page': {
			handler(e) {
				this.searchPricing();
			}
		}
	},
	data() {
		return {
			notFoundExcelItemsFields: {
				'h-code': 'barcode',
				'цена': 'price'
			},
			activeTabIndex: 0,
			allDep: false,
			publicPath: process.env.BASE_URL,
			departments: [],
			excelDepIds: [],
			notFoundExcelItems: [],
			foundExcelItems: [],
			depIds: [],
			form: {
				fileExcel: null,
			},
			root: {
				name: "Bosilsin",
				children: [
					{
						name: "music",
						children: [
							{
								name: "song",
								name1: "song",
								name2: "song",
							},
						],
					},
				],
			},
			filterCurrencyId: null,
			json_fields1: {
				'Документ дата': 'docDate',
				'Документ №': 'docNumber',
				'Название': 'name',
				'Цвет': 'colorName',
				'Штрихкод': 'barcode',
				'Артикул': 'artikul',
				'Цена (приход)': 'incomeUzs',
				'Оптовая цена (новая)': 'newPriceWholesale',
				'Оптовая цена (последняя)': 'priceWholesale',
				'Розничная цена (новая)': 'newPriceUzs',
				'Розничная цена (последняя)': 'priceUzs'
			},
			clearTable: '',
			pricingStatus: '',
			pricingStatus2: '',
			count: 0,
			loader: false,
			toggleSearch: {
				filter: false
			},
			toggleForm: {
				form: false
			},
			getPricedItems: [],
			filter: {
				id: null,
				departmentId: [],
				start: '',
				end: '',
				depsId: [],
				barcode: null,
				multiBarcode: null,
				name: null,
				category: 'all',
				artikul: '',
				docIdAndDocName: '',
				page: 1,
				limit: 20
			},
			tableFilter: '',
			currency: this.userDepCurrencyCode,
			depCurrencyName: this.userDepCurrencyName,
			emptyErrorTable: false,
			newItem: [],
			items: [],
			currentDate: '',
			selectedDepartment: [],
			isValid: '',
			ok: true,
			regnumber: '',
			comment: '',
			activeSidebar: false,
			isErrorDepartment: false,
			validDate: true,
			search: '',
			allCategory: [],
			companyType: '',
			categoryCode: null,
			subcategory: {
				items: [],
				value: null,
				isDisabled: true,
			},
			subsubcategory: {
				items: [],
				value: null,
				isDisabled: true,

			},
			sub3category: {
				items: [],
				value: null,
				isDisabled: true,
			},
			disabled: true,
			attr: {},
			pendingItems: [],
			pendingCols: [
				{
					key: 'id',
					label: '№'
				},
				{
					key: 'regNumber',
					label: 'Документ номер'
				},
				{
					key: 'regDate',
					label: 'Дата'
				},
				{
					key: 'fromDepartmentName',
					label: 'Отправитель'
				},
				{
					key: 'toDepartmentName',
					label: 'Получатель'
				},
				{
					key: 'barcode',
					label: 'СпецКод'
				},
				{
					key: 'itemName',
					label: 'Наименование'
				},
				{
					key: 'count',
					label: 'Кол-во'
				},
				{
					key: 'priceUzs',
					label: 'Цена'
				},
			],
			viewPendingItems: false,
			confirmModal: false,
			confirmData: []
		}
	},
	props: {
		isFromExcel: {
			type: Boolean,
			default: false
		},
		editable: {
			type: Boolean,
			default: false
		},
		editItem: {
			type: Object,
			default: null
		},
		isSidebarOpen: {
			type: Boolean,
			default: false
		},
		caption: {
			type: String,
			default: 'Users'
		},
		hover: {
			type: Boolean,
			default: true
		},
		striped: {
			type: Boolean,
			default: true
		},
		bordered: {
			type: Boolean,
			default: false
		},
		small: {
			type: Boolean,
			default: false
		},
		fixed: {
			type: Boolean,
			default: false
		}
	},

	computed: {

		...mapState('references', [
			'excelFields'
		]),
		...mapState('references', [
			'refCurrencies'
		]),
		computedFields() {
			return [
				{
					key: 'id',
					label: '№',
					sortable: true
				},
				{
					key: 'details',
					label: this.$t('prices.item.details'),
					'class': 'width26percent',
				},
				{
					key: 'barcode',
					label: this.$t('goods.special-barcode'),

				},
				{
					key: 'multiBarcode',
					label: this.$t('goods.barcode'),
				},
				{
					key: 'incomePrice',
					label: 'Приход цена',
				},
				{
					key: 'uzb',
					label: this.$t('prices.item.lastPriceUzs'),
					'class': 'width6Percent',
				},
				{
					key: 'newUzb',
					label: this.$t('prices.item.sum-new'),
				}

			]
		},
		/* THIS IS FOR SMALL TABLE UNDER THE FILTER */
		computedFieldsFilter() {
			return [
				{
					key: 'index',
					label: '№',
					'class': 'min-10 text-center',
					sortable: true
				},
				{
					key: 'itemId',
					label: 'Id',
					'class': 'min-10 text-center',
					sortable: true
				},
				{
					key: 'details',
					label: this.$t('prices.item.details')
				},
				{
					key: 'barcode',
					label: this.$t('goods.special-barcode'),

				},
				{
					key: 'multiBarcode',
					label: this.$t('goods.barcode'),

				},
				{
					key: 'oldPriceUzs',
					label: this.$t('prices.item.lastPriceUzs')
				},
				{
					key: 'uzb',
					label: this.$t('prices.item.sum-new')
				},
				{
					key: 'actions',
					label: this.$t('actions.title'),
					class: 'text-center'
				}
			]
		},
		clearPricingFilter() {
			this.clearTable = '';
		},
		disabledComputed() {
			if (this.regnumber.length === 0) {
				return false;
			} else {
				return true
			}
		},
		listWarehouse() {
			return this.departments.filter(item => {
				return item.typeName === 'COMPANY' || item.typeName === 'SHOP';
			})
		},
		isInvalid() {
			return this.isErrorDepartment && this.selectedDepartment.length === 0
		},
		isInvalidDate() {
			if (this.currentDate === '') {
				return true
			} else {
				return false
			}
		},
		...mapGetters('prices', [
			'getPrices', 'getDepartments', 'getRegNumber', 'getLastItems', 'getEditItems', 'getDocId'
		]),
		...mapState('prices', [
			'lastOriginalItems', 'totalItems'
		]),
		...mapState(['userDepCurrencyName', 'userDepCurrencyCode']),
	},
	async created() {
		await this.getReferenceChildren('CURRENCY');
		await this.loadCategory();
		await this.setCompanyType();
		await DepartmentsService.getDepartments().then((res) => {
			this.departments = res.data;
		});
	},
	methods: {
		...mapActions('references', [
			'getReferenceChildren',
		]),
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		resetExcelTabData() {
			this.excelDepIds = []
			this.notFoundExcelItems = []
			this.foundExcelItems = []
			this.form.fileExcel = null
		},
		normalizer(node) {
			if (!node.children || node.children.length === 0) {
				delete node.children
				return {
					id: node.id,
					label: node.name,
				}
			}
			return {
				id: node.id,
				label: node.name,
				children: node.children && node.children.length > 0 ? node.children : [],
			}
		},
		async download() {
			await ReferencesService.upLoudExcel(this.form.fileExcel).then(res => {
				this.foundExcelItems = res.data.foundItems
				this.notFoundExcelItems = res.data.notFoundItems
			})
		},
		currencyChanged(selectedCurrencyId) {
			let selectedDeps = this.getDepartments.filter(dep => {
				if (selectedCurrencyId) {
					if (dep.currencyId === selectedCurrencyId) {
						return dep;
					}
				}
			})
			this.selectedDepartment = selectedDeps;
		},
		clearPricing() {
			this.tableFilter = ''
		},
		saveREADY(status) {
			this.pricingStatus = status;
			this.onSave();
		},
		async saveForExcel(status) {
			this.pricingStatus2 = status;
			if (this.regnumber != '') {
				if (this.excelDepIds.length > 0) {
					if (this.currentDate !== '') {
						const result1 = this.foundExcelItems.map((item, index) => {
							return {
								itemId: item.itemId,
								priceUzs: item.price,
								oldPriceUzs: item.oldPriceUzs
							};
						});
						let getFilteredArray = result1;
						if (getFilteredArray.length === 0 && this.getPricedItems.length === 0) {
							this.emptyErrorTable = true
						} else {
							if (getFilteredArray.length > 0) {
								this.getPricedItems.push(...getFilteredArray);
							}
							let data = {
								id: this.filter.id ? this.filter.id : this.getDocId,
								costNumber: this.regnumber,
								costDate: this.currentDate,
								companiesIds: this.excelDepIds,
								pricingItems: this.count == 1 ? getFilteredArray : this.getPricedItems,
								comment: this.comment,
								pricingStatus: this.pricingStatus2,
								byExcel: true
							}
							if (this.editable) {
								if (this.count == 0) {
									if (getFilteredArray.length > 0) {
										data.pricingItems = getFilteredArray;
									} else {
										data.pricingItems = this.getPricedItems;
									}
								}
								if (this.count == 1) {
									data.pricingItems = this.getPricedItems;
								}

							}
							await this.createPricesExcel(data);
							this.departments = [];
							this.filter.barcode = null;
							this.filter.multiBarcode = null;
							this.currentDate = '';
							this.filter.id = null;
							this.count = 0;
							this.filter.name = null;
							this.filter.category = 'all';
							this.toggleSearch.filter = false;
							this.toggleForm.form = false;
							this.subcategory.value = null;
							this.subcategory.isDisabled = true;
							this.subsubcategory.isDisabled = true;
							this.sub3category.isDisabled = true;
							this.filter.artikul = '';
							this.tableFilter = '';
							this.subsubcategory.value = null;
							this.regnumber = ''
							this.comment = '';
							this.selectedDepartment = []
							await this.$emit('closeSidebar')

							this.emptyErrorTable = false
							this.regnumber = ''
							this.selectedDepartment = []
							this.items = []
							this.isErrorDepartment = false
							this.isValid = ''
							this.getPricedItems = [];
						}
					}
				} else {
					this.$vs.notify({
						text: this.$t('Please select department!'),
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				}

			} else {
				this.isValid = false
			}
		},
		filterPricing() {
			const result1 = this.items.map((item) => {
				return {
					itemId: item.itemId,
					priceUzs: item.newPriceUzs,
					oldPriceUzs: item.priceUzs,
					priceWholesale: item.newPriceWholesale,
					name: item.name,
					artikul: item.artikul,
					barcode: item.barcode,
					multiBarcodes: item.multiBarcodes,
					color: item.color,
					size: item.size
				};
			});

			let getFilterArray = result1.filter((item) => {
				if (item.priceUzs > 0 || item.priceWholesale > 0) {
					return item;
				}
			});
			if (getFilterArray.length > 0) {
				if (this.getPricedItems.length > 0) {
					this.getPricedItems.forEach((tmp, index) => {
						getFilterArray.forEach((t, i) => {
							if (tmp.itemId === t.itemId) {
								getFilterArray.splice(i, 1)
							}
						})
					})
					this.getPricedItems.push(...getFilterArray);
				} else {
					this.getPricedItems.push(...getFilterArray);
				}
			}
			return this.getPricedItems;
		},

		setCategoryCode(value) {
			this.allCategory.filter(el => {
				if (el.id === value) {
					this.categoryCode = el.code
				}
			})
		},
		async searchPricing() {
			if (this.selectedDepartment) {
				if (this.selectedDepartment.length > 0) {
					this.count++;
					await this.setFilterToComponent()
					this.loader = true;
					await this.getSearchGeneral(this.attr.link);
					this.items = this.getLastItems;
				} else {
					this.$vs.notify({
						title: "Выберите Подразделение",
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}
			} else {
				this.$vs.notify({
					title: "Выберите Подразделение",
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
			}

			this.loader = false;
		},
		subSubCategorySelected() {
			if (this.subsubcategory.value !== null) {
				this.sub3category.isDisabled = false
				this.sub3category.value = null
				this.setFilterToComponent()
				this.loadSub3Category(this.subsubcategory.value);
			} else {
				this.sub3category.isDisabled = true
				this.sub3category.value = null

			}

		},
		deleteItem(index) {
			this.getPricedItems.splice(index, 1)
		},
		categorySelected() {
			this.subcategory.isDisabled = true
			this.loadSubCategory(this.filter.category)
			this.setFilterToComponent()
			// if(this.filter.category === 'all'){
			// 	this.subcategory.isDisabled = true
			// 	this.subsubcategory.isDisabled = true
			// }else{
			// 	this.subcategory.isDisabled = false
			// 	this.loadSubCategory(this.filter.category)
			// }
			// this.setFilterToComponent()
		},
		subCategorySelected() {
			this.subsubcategory.isDisabled = false
			if (this.subcategory.value != null) {
				this.loadSubSubCategory(this.subcategory.value)
				this.subsubcategory.value = null;
				this.sub3category.value = null;
				this.sub3category.isDisabled = true;
			} else {
				this.subsubcategory.value = null;
				this.sub3category.value = null;
				this.subsubcategory.isDisabled = true
				this.sub3category.isDisabled = true
			}
		},
		async loadCategory() {
			await ReferencesService.getReferenceChildren(`WAREHOUSE_CATEGORY`).then(response => {
				this.allCategory = response.data;
			})
		},
		loadSubCategory(id) {
			if (id == 'all') {
				this.subcategory.isDisabled = true;
			}
			this.subcategory.isDisabled = true;
			ReferencesService.getSubReferenceChildren(id).then(response => {
				if (response.data) {
					this.subcategory.items = response.data;
				} else {
					this.subcategory.items = null;
				}
				this.subcategory.isDisabled = true;
			})
		},
		loadSubSubCategory(id) {
			if (id == null) {
				this.subsubcategory.isDisabled = true
			}
			this.subsubcategory.isDisabled = true
			ReferencesService.getSubReferenceChildren(id).then(response => {
				this.subsubcategory.items = response.data;
				this.subsubcategory.isDisabled = false

			})
		},
		async loadSub3Category(id) {
			await ReferencesService.getSubReferenceChildren(id).then(response => {
				this.sub3category.items = response.data;
			})
		},
		setCompanyType() {
			this.companyType = TokenService.getDepartmentType()
			if (this.companyType === 'SHOP') {
				this.allCategory.filter(el => {
					if (el.code === 'MAGAZIN') {
						this.filter.category = el.id
					}
				})

				this.loadSubCategory(this.filter.category)
				//this.subcategory.isDisabled = false;
			}

		},
		setFilterToComponent() {
			this.filter.depsId = []
			let depNames = []
			if (Object.keys(this.selectedDepartment).length !== 0) {
				this.selectedDepartment.forEach(item => {
					this.filter.depsId.push(item.id)
					depNames.push(item.name)
				})
				this.disabled = false
				this.attr['departmentId'] = 10;
				this.attr['empty'] = false
				this.attr['depNames'] = depNames
				let obj = {
					departmentIds: this.filter.depsId,
					catId: this.filter.category === 'all' ? 14 : this.filter.category,
					barcode: this.filter.barcode !== '' ? this.filter.barcode : null,
					multiBarcode: this.filter.multiBarcode !== '' ? this.filter.multiBarcode : null,
					name: this.filter.name !== '' ? this.filter.name : null,
					artikul: this.filter.artikul !== '' ? this.filter.artikul : null,
					subId: this.subcategory.value !== null ? this.subcategory.value : null,
					sub2Id: this.subsubcategory.value !== null ? this.subsubcategory.value : null,
					sub3Id: this.sub3category.value !== null ? this.sub3category.value : null,
					page: this.filter.page,
					limit: this.filter.limit
				}
				let str = "?departmentIds=" + this.filter.depsId +
					"&catId=" + this.filter.category +
					//						"&start=" + `${ this.filter.start !== '' && this.filter.start !== '__-__-____' ? this.filter.start : null}` +
					//						"&end=" + `${ this.filter.end !== '' && this.filter.end !== '__-__-____' ? this.filter.end : null}` +
					"&barcode=" + `${this.filter.barCode !== '' ? this.filter.barCode : null}` +
					"&name=" + `${this.filter.name !== '' ? this.filter.name : null}` +
					"&artikul=" + `${this.filter.artikul !== '' ? this.filter.artikul : null}` +
					"&subId=" + `${this.subcategory.value !== null ? this.subcategory.value : null}` +
					"&sub2Id=" + `${this.subsubcategory.value !== null ? this.subsubcategory.value : null}` +
					"&sub3Id=" + `${this.sub3category.value !== null ? this.sub3category.value : null}` +
					"&docIdAndDocName=" + `${this.filter.docIdAndDocName !== '' ? this.filter.docIdAndDocName : null}`


				this.attr['link'] = obj
				//					this.$emit('filter', this.attr);

			} else {
				this.disabled = true
				this.filter.category = 'all'
				this.subcategory.isDisabled = true
				this.subcategory.value = null
				this.subsubcategory.isDisabled = true
				this.subsubcategory.value = null
				this.attr['empty'] = true
				this.attr['departmentId'] = 10;
				//					this.$emit('filter', this.attr);
				this.filter.depsId = []
				depNames = []
			}
		},
		async handleNewDepartment(newDep) {
			this.subcategory.isDisabled = false;
			if (this.selectedDepartment.length > 0) {
				this.currency = this.selectedDepartment[0].currencyCode;
				this.depCurrencyName = this.selectedDepartment[0].currencyName;
				if (this.currency == newDep.currencyCode) {
					this.selectedDepartment.push(newDep);
				} else {
					this.$vs.notify({
						title: this.$t('prices.notify'),
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}
			} else {
				this.selectedDepartment.push(newDep);
				this.currency = newDep.currencyCode;
				this.depCurrencyName = newDep.currencyName;
			}
			/*let departments = this.selectedDepartment.map((department) => {
				return department.id
			});*/
			//				await this.getLastItemList(departments)
			//				this.items = this.getLastItems

		},
		async removeDepartment(dep) {
			await this.selectedDepartment.splice(this.selectedDepartment.indexOf(dep), 1);
			let departments = await this.selectedDepartment.map((department) => {
				return department.id;
			});
			//				await this.getLastItemList(departments)
			// 				this.items = this.getLastItems
			if (this.selectedDepartment.length === 0) {
				this.currency = this.userDepCurrencyCode;
				this.depCurrencyName = this.userDepCurrencyName;
			}
		},
		async closeSidebar() {
			this.selectedDepartment = [];
			this.filter.barcode = null;
			this.filter.multiBarcode = null;
			this.filter.name = null;
			this.toggleSearch.filter = false;
			this.toggleForm.form = false;
			this.count = 0;
			this.filter.category = 'all';
			this.subcategory.value = null;
			this.subsubcategory.value = null;
			this.sub3category.value = null;
			this.filter.artikul = '';
			this.filter.docIdAndDocName = '';
			this.tableFilter = '';

			this.regnumber = ''
			this.comment = '';
			this.selectedDepartment = []
			this.isValid = ''
			this.isErrorDepartment = false
			// this.ok = false
			this.items = []
			this.currency = this.userDepCurrencyCode;
			this.depCurrencyName = this.userDepCurrencyName;
			this.emptyErrorTable = false
			this.subcategory.isDisabled = true;
			this.subsubcategory.isDisabled = true;
			this.sub3category.isDisabled = true;
			this.getPricedItems = [];
			//				this.getDateCurrent()
			await this.$emit('closeSidebar')

		},

		generateRegNumber() {
			this.getRegNumberItem()
			this.regnumber = this.getRegNumber
			this.isValid = true
		},
		async onSave() {
			if (this.regnumber != '') {
				if (this.selectedDepartment.length > 0) {
					if (this.currentDate !== '') {
						const result = this.items.map((item, index) => {
							return {
								itemId: item.itemId,
								priceUzs: item.newPriceUzs ? item.newPriceUzs.replace(/\s/g, "") : item.newPriceUzs,
								oldPriceUzs: item.priceUzs,
								priceWholesale: item.newPriceWholesale ? item.newPriceWholesale.replace(/\s/g, "") : item.newPriceWholesale,
								docId: item.docId,
								depId: item.depId
							};
						});
						let getFilteredArray = result.filter((item) => {
							if (this.lastOriginalItems.length !== 0) {
								let foundIndex = this.lastOriginalItems.findIndex(el => {
									return el.itemId == item.itemId;
								})
								if (foundIndex > -1) {
									/*if (item.incomeUzs !== this.lastOriginalItems[foundIndex].incomeUzs || item.priceUzs > 0) {
										if (!item.priceUzs) {
											item.priceUzs = this.lastOriginalItems[foundIndex].priceUzs;
										}
										return item;
									}*/
									/* NEW CODE 24.08.2019 */
									if (item.priceWholesale || item.priceUzs) {
										if (!item.priceUzs) {
											item.priceUzs = this.lastOriginalItems[foundIndex].priceUzs;
										}
										if (!item.priceWholesale) {
											item.priceWholesale = this.lastOriginalItems[foundIndex].priceWholesale;
										}
										return item;
									}
								}
							} else if (this.getEditItems.pricingItems.length !== 0) {
								let foundIndex = this.getEditItems.pricingItems.findIndex(el => {
									return el.itemId == item.itemId;
								})
								if (foundIndex > -1) {
									/*if (item.incomeUzs !== this.getEditItems.pricingItems[foundIndex].incomeUzs || item.priceUzs > 0) {
										if (!item.priceUzs) {
											item.priceUzs = this.getEditItems.pricingItems[foundIndex].priceUzs;
										}
										return item;
									}*/
									/* NEW CODE 24.08.2019 */
									if (item.priceWholesale || item.priceUzs) {
										if (!item.priceUzs) {
											item.priceUzs = this.getEditItems.pricingItems[foundIndex].priceUzs;
										}
										if (!item.priceWholesale) {
											item.priceWholesale = this.getEditItems.pricingItems[foundIndex].priceWholesale;
										}
										return item;
									}
								}
							}
						});
						if (getFilteredArray.length === 0 && this.getPricedItems.length === 0) {
							this.emptyErrorTable = true
						} else {
							let departments = this.selectedDepartment.map((department) => {
								return department.id
							});
							if (getFilteredArray.length > 0) {
								this.getPricedItems.push(...getFilteredArray);
							}
							let data = {
								id: this.filter.id ? this.filter.id : this.getDocId,
								costNumber: this.regnumber,
								costDate: this.currentDate,
								companiesIds: departments,
								pricingItems: this.count == 1 ? getFilteredArray : this.getPricedItems,
								comment: this.comment,
								pricingStatus: this.pricingStatus,
							}
							if (this.editable) {
								if (this.count == 0) {
									if (getFilteredArray.length > 0) {
										data.pricingItems = getFilteredArray;
									} else {
										data.pricingItems = this.getPricedItems;
									}
								}
								if (this.count == 1) {
									data.pricingItems = this.getPricedItems;
								}
							}
							if (this.isFromExcel) {
								await this.createPricesExcel(data);
								// this.ok = false
								this.selectedDepartment = [];
								this.filter.barcode = null;
								this.filter.multiBarcode = null;
								this.currentDate = '';
								this.filter.id = null;
								this.count = 0;
								this.filter.name = null;
								this.filter.category = 'all';
								this.toggleSearch.filter = false;
								this.toggleForm.form = false;
								this.subcategory.value = null;
								this.subcategory.isDisabled = true;
								this.subsubcategory.isDisabled = true;
								this.sub3category.isDisabled = true;
								this.filter.artikul = '';
								this.tableFilter = '';
								this.subsubcategory.value = null;
								this.regnumber = ''
								this.comment = '';
								this.selectedDepartment = []
								await this.$emit('closeSidebar')

								this.emptyErrorTable = false
								this.regnumber = ''
								this.selectedDepartment = []
								this.items = []
								this.isErrorDepartment = false
								this.isValid = ''
								this.getPricedItems = [];
							} else {
								if (data.pricingStatus === 'READY') {
									await PricesService.getPendingDocPrices(data).then(res => {
										if (res.data && res.data.length>0) {
											this.pendingItems = res.data
											this.viewPendingItems = true
											return 0;
										} else {
											this.confirmData = data
											this.confirmModal = true
										}
									}).catch(e => {
										this.$vs.notify({
											title: "Ошибка на сервере",
											color: 'warning',
											icon: 'close',
											position: 'top-right'
										});
										return 0;
									})
								} else {
									await this.createPricesList(data);
									// this.ok = false
									this.selectedDepartment = [];
									this.filter.barcode = null;
									this.filter.multiBarcode = null;
									this.currentDate = '';
									this.filter.id = null;
									this.count = 0;
									this.filter.name = null;
									this.filter.category = 'all';
									this.toggleSearch.filter = false;
									this.toggleForm.form = false;
									this.subcategory.value = null;
									this.subcategory.isDisabled = true;
									this.subsubcategory.isDisabled = true;
									this.sub3category.isDisabled = true;
									this.filter.artikul = '';
									this.tableFilter = '';
									this.subsubcategory.value = null;
									this.regnumber = ''
									this.comment = '';
									this.selectedDepartment = []
									await this.$emit('closeSidebar')

									this.emptyErrorTable = false
									this.regnumber = ''
									this.selectedDepartment = []
									this.items = []
									this.isErrorDepartment = false
									this.isValid = ''
									this.getPricedItems = [];
								}
							}
						}
					}
				} else {
					this.isErrorDepartment = true
				}

			} else {
				this.isValid = false
			}
		},
		async save() {
			await this.createPricesList(this.confirmData);
			// this.ok = false
			this.selectedDepartment = [];
			this.filter.barcode = null;
			this.filter.multiBarcode = null;
			this.currentDate = '';
			this.filter.id = null;
			this.count = 0;
			this.filter.name = null;
			this.filter.category = 'all';
			this.toggleSearch.filter = false;
			this.toggleForm.form = false;
			this.subcategory.value = null;
			this.subcategory.isDisabled = true;
			this.subsubcategory.isDisabled = true;
			this.sub3category.isDisabled = true;
			this.filter.artikul = '';
			this.tableFilter = '';
			this.subsubcategory.value = null;
			this.regnumber = ''
			this.comment = '';
			this.selectedDepartment = []
			await this.$emit('closeSidebar')

			this.emptyErrorTable = false
			this.regnumber = ''
			this.selectedDepartment = []
			this.items = []
			this.isErrorDepartment = false
			this.isValid = ''
			this.getPricedItems = [];
			this.confirmModal = false
		},
		recursive(arr) {
			arr.reduce((a, item) => {
				if (item.children) return this.recursive(item.children);
				return this.depIds.push(item.id);
			}, null)
		},
		focusInput($event, index, inputOrder) {
			let lastIndex = this.getLastItems.length - 1;
			if ($event.keyCode == 37) {
				if (inputOrder == 2 && index == 0) {
					return 1
				}
				if (inputOrder == 1) {
					let refName = index.toString() + '2'
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
					return
				}
				if (inputOrder == 2) {
					let refName = (index - 1).toString() + (parseInt(inputOrder) - 1).toString()
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
					return
				}
				let refName = index.toString() + inputOrder.toString()
				this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
				this.$refs[refName].$el.focus()
			}
			if ($event.keyCode == 39) {
				if (inputOrder == 1 && lastIndex == index) {
					return 1
				}
				if (inputOrder == 2) {
					let refName = index.toString() + '1'
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
					return
				}
				let refName = (index + 1).toString() + (parseInt(inputOrder) + 1).toString()
				this.$refs[refName].$el.focus()
				this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
			}
			if ($event.keyCode == 38) {
				if (index == 0) {
					return 1
				}
				let refName = (index - 1).toString() + (inputOrder).toString()
				this.$refs[refName].$el.focus()
				this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
			}
			// down
			if ($event.keyCode == 40) {
				if (index == lastIndex) {
					return 1
				}
				let refName = (index + 1).toString() + (inputOrder).toString()
				this.$refs[refName].$el.focus()
				this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
			}

		},
		async OkFunction(refName) {
			await this.changeOk();
			await this.focusRef(refName)
		},
		changeOk() {
			this.ok = true;
			return true
		},
		focusRef(refName) {
			this.$refs[refName].focus();
			this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
			return true;
		},
		...mapActions('prices', [
			'getPricesList', 'createPricesList', 'createPricesExcel', 'getDepartmentList', 'getRegNumberItem', 'getLastItemList', 'getSearchGeneral'
		]),
		getDepartmentsLocal() {
			return this.getDepartments
		},
		getPricesLocale() {
			//				this.items = this.getLastItems
		}
	},

	components: {
		MaskedInput,
		Multiselect,
		PriceFilter,
		TreeView
	},
}
</script>

<style scoped>
.emptyErrorTable {
	display: flex;
	justify-content: center;
	padding: 4px 0 7px 0;
}

.edit_price {
	cursor: pointer;
}

.inputWidth {
	width: 152px;
	height: 16px;
	text-align: center;
}

.widthTd {
	text-align: center !important;
}

.btn-frame {
	display: flex;
	justify-content: flex-end;
	margin-top: 10px;
}

.move {
	height: 20px !important;
	margin-left: 2px;
	width: 70px;
}

.top-card {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.isErrorDepartment {
	color: red;
	font-size: 12px;
	margin-left: 20px;
}

.redStar {
	color: red;
}

.b-table.table > thead > tr > th,
.b-table.table > thead > tr > td,
.b-table.table > tfoot > tr > th,
.b-table.table > tfoot > tr > td {
	text-align: center;
}

.spinner-wrapper {
	position: absolute;
	background: rgba(32, 28, 32, 0.49);
	left: 0;
	right: 0;
	text-align: center;
	top: 0;
	bottom: 0;
	padding-top: 35px;
	z-index: 5;
}

.table-wrapper {
	position: relative;
	padding: 5px;
}

.emptyDivForPricing {
	width: 70px;
	height: 20px;
}

.fixedHeader {
	position: fixed;
}
</style>
